// extracted by mini-css-extract-plugin
export default {"certificates-tab-view":"CertificatesTabView_certificates-tab-view__I+ZnH"};